export default __webpack_public_path__ + "static/media/sopimus-white.ab0a16bd.svg";